import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService, HttpService } from '../../../tms-shared';
import { Comment, CreateComment } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class BaseCommentService extends BaseService {
  constructor(
    protected baseRoute: string,
    protected httpService: HttpService,
  ) {
    super(baseRoute, httpService);
  }

  get(id: string): Observable<Comment[]> {
    return this.httpService.get<Comment[]>(`${this.apiUrl}/${id}`);
  }

  getOneRecord(id: string): Observable<Comment[]> {
    return this.httpService.get<Comment[]>(`${this.apiUrl}/GetOneRecord?id=${id}`);
  }

  save(model: CreateComment): Observable<any> {
    return this.httpService.post(this.apiUrl, model);
  }

  update(model: Comment): Observable<any> {
    return this.httpService.put(this.apiUrl, model);
  }

  delete(id: string): Observable<any> {
    return this.httpService.delete(`${this.apiUrl}/${id}`);
  }
}
